/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Smokedefect1Inputs */



/**
* | output |
* | --- |
* | "Smoke fault" |
*
* @param {Ahu_History_Key_Smokedefect1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_smokedefect1 = /** @type {((inputs?: Ahu_History_Key_Smokedefect1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Smokedefect1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Smoke fault")
	return /** @type {LocalizedString} */ ("Défaut fumée")
});
export { ahu_history_key_smokedefect1 as "ahu_history_key_smokeDefect" }